import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import {
  Button
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import CustomCircleLoader from './CustomCircleLoader';
import s from './Loader.css';

class ButtonLoader extends Component {

  static propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    handleClick: PropTypes.any,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    spinnerColor: PropTypes.string,
    spinnerSecondaryColor: PropTypes.string,
  };

  static defaultProps = {
    label: 'Submit',
    show: false,
    type: 'button',
    spinnerColor: '#fff',
    spinnerSecondaryColor: '#D32F2F'
  };

  render() {
    const { label, show, type, handleClick, className, disabled, spinnerColor, isSecondary, spinnerSecondaryColor } = this.props;
    let isDisabled = false;
    if (show || disabled) {
      isDisabled = true;
    }
    return (
      <Button
        className={className}
        disabled={isDisabled}
        type={type}
        onClick={handleClick}
      >
        {
          show && <CustomCircleLoader
            singleColor={isSecondary ? spinnerSecondaryColor : spinnerColor}
            size={isSecondary ? 12 : 18}
            borderSize={2} />
        }
        {' ' + label}
      </Button>
    );
  }
}

export default withStyles(s)(ButtonLoader);